export default {
  title: 'Add credit card',
  buttons: {
    save: 'Save',
  },
  feedback: {
    success: 'Successfully added card',
  },
};
